<template>
	<header class="header">
		<div class="container">
			<div class="header__logo-wrapper">
				<div class="header__logo"></div>
			</div>
			<h1 class="header__headline">{{ $t("home.header.headline_discover") }} {{eventsCount}}  {{ $t("home.header.headline_rest") }}</h1>
			<form class="header__form" action="">
				<div class="filter__wrapper" :class="{open: 'breed' === showList, close: 'breed' !== showList}">
					<input type="text"
						   :placeholder="$t('home.header.inputs.breed')"
						   class="filter"
						   id="breed"
						   :class="{open: 'breed' === showList, close: 'breed' !== showList}"
						   @click="updateShowList('breed')"
						   @input="showList = 'breed'"
						   v-model="searchByBreed"
						   autocomplete="off"
					>
					<ul v-if="'breed' === showList"
						class="filter__list"
					>

						<li v-for="item in breedsList"
							class="filter__list-item"
							@click="selectBreedFilter(item)"
						>
							{{item.name}}
						</li>
					</ul>
				</div>


				<div class="filter__wrapper" :class="{open: 'country' === showList, close: 'country' !== showList}">
					<input type="text"
						   :placeholder="$t('home.header.inputs.country')"
						   class="filter"
						   id="country"
						   :class="{open: 'country' === showList, close: 'country' !== showList}"
						   @click="updateShowList('country')"
						   @input="showList = 'country'"
						   v-model="searchByCountry"
						   autocomplete="off"
					>
					<ul v-show="'country' === showList"
						class="filter__list"
					>

						<li v-for="item in countryList"
							class="filter__list-item"
							@click="selectCountryFilter(item)"
						>
							{{item.name}}
						</li>
					</ul>
				</div>


				<router-link
					:to="{name: 'EventsList', query: { breed: breedId, country: countryCode }}"
					class="header__btn"
				>
					{{ $t("home.header.button") }}
				</router-link>
			</form>
		</div>
	</header>
</template>

<script>
	import { mapActions } from 'vuex'
	import axios from 'axios'

	export default {
		data () {
			return {
				params: [],
				showList: '',
				searchByBreed: '',
				searchByCountry: '',
				breedId: '',
				countryCode: '',
				eventsCount: ''
			}
		},
		methods: {
			...mapActions(['fetchBreeds']),
			...mapActions(['fetchCountries']),
			updateShowList (list) {
				if (this.showList === list) {
					this.showList = ''
				} else {
					setTimeout(() => {
						this.showList = list
					}, 0)
				}
			},
			closeFlitersLists (e) {
				const open = document.querySelector('.open')
				if (open && !e.target.matches('.filter__list, .filter__list *')) {
					this.showList = ''
				}
			},
			selectBreedFilter (item) {
				// const inputBreed = document.getElementById('breed')
				this.breedId = item.id
				this.showList = ''
				this.searchByBreed = item.name
			},
			selectCountryFilter (item) {
				// const inputCountry = document.getElementById('country')
				this.countryCode = item.code
				this.showList = ''
				this.searchByCountry = item.name
			},
			fetchEvent () {
				axios.get('/api/events/', {})
					.then(response => {
						this.eventsCount = response.data.count
					})
					.catch(error => {
						console.error(error)
					})
			}
		},
		computed: {
			breedsList () {
				const inputTest = person => {
					const regExp = new RegExp('^' + this.searchByBreed, 'i')
					return regExp.test(person.name)
				}
				return this.$store.state.events.breeds.filter(inputTest)
			},
			countryList () {
				const inputTest = person => {
					const regExp = new RegExp('^' + this.searchByCountry, 'i')
					return regExp.test(person.name)
				}
				return this.$store.state.events.countries.filter(inputTest)
			}
		},
		created () {
			window.addEventListener('click', this.closeFlitersLists)
			this.fetchBreeds()
			this.fetchCountries()
			this.fetchEvent()
		}
	}
</script>

<style lang="scss" scoped>
	@import "../../styles/variables.scss";
	@import "../../styles/filters.scss";

	.header {
		background-image: url('/static/img/background.jpg');
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;
		padding: 120px 0 55px;
		&__logo-wrapper {
			position: relative;
			width: 362px;
			margin: 0 auto;
			&::after {
				content: '';
				display: block;
				position: absolute;
				top: -75px;
				right: -45px;
				width: 70px;
				height: 100px;
				background-image: url('/static/img/badge.svg');
			}
		}
		&__logo {
			display: block;
			margin: 0 auto 40px;
			width: 362px;
			height: 93px;
			background-image: url('/static/img/logo-big.svg');
			background-size: cover;
			background-position: center;
			background-repeat: no-repeat;
		}
		&__headline {
			margin: 0 auto 20px;
			text-align: center;
			color: $gold;
			font-size: 16px;
			width: 250px;
		}
		&__form {
			display: flex;
			flex-flow: column;
			align-items: center;
		}
		&__btn {
			display: block;
			cursor: pointer;
			border: none;
			background-color: $gold;
			width: 100%;
			max-width: 295px;
			height: 50px;
			font-family: $lato-bold;
			font-size: 16px;
			color: #fff;
			text-transform: uppercase;
			text-decoration: none;
			padding: 15px 0;
		}
		::placeholder {
			font-family: $lato;
			font-size: 14px;
			color: #999999;
		}
	}

	.filter {
		max-width: 295px;
		margin-bottom: 0;
		&__wrapper {
			width: 100%;
			max-width: 295px;
			margin-bottom: 10px;
		}
		&__list {
			width: 100%;
			max-width: 100%;
		}
	}

	// Extra small devices (portrait phones, less than 576px)
	@media (max-width: 575.98px) {
		.header {
			padding: 40px 0 25px;
			background-image: url('/static/img/background-mobile.jpg');
			/*filter: brightness(50%);*/
			&__logo-wrapper {
				position: relative;
				width: 100%;
				margin: 0 auto;
				&::after {
					display: none;
				}
			}
			&__logo {
				margin: 0 auto;
				margin-bottom: 15px;
				width: 164px;
				height: 43px;
			}
			&__headline {
				font-size: 13px;
				width: 180px;
				margin-bottom: 175px;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/Home/HeaderComponent.vue